export const homeAnimation = {
    hidden: {x: -400, opacity:0},
    show: {x:0, opacity: 1 },
};

export const homeInfoAnimation = {
    hidden: {x: 100, opacity:0 },
    show: {x:0, opacity: 1 },
};

export const  homeInfoAnimation2 = {
    hidden: {y: 100, opacity:0 },
    show: {y:0, opacity: 1 },
}

export const navAnimation = {
    hidden: {y: -20, opacity:0 },
    show: {y:0, opacity: 1 },
};


export const servicesAnimations = {
    hidden: {y: 220, opacity:0 },
    show: {y:0, opacity: 1 },
};

export const portfolioAnimations = {
    hidden: {scale: 0, opacity:0 },
    show: {scale:1, opacity: 1 },
}

export const milestonesAnimations = {
    hidden: {scale: 0, opacity:0 },
    show: {scale:1, opacity: 1 },
}

export const blogsAnimations = {
    hidden: {y: 200, opacity:0 },
    show: {y:0, opacity: 1 },
};

export const videoAnimations = {
    hidden: {scale: 0, opacity:0 },
    show: {scale:1, opacity: 1 },
}

export const priceAnimations = {
    hidden: {y: 200, opacity:0 },
    show: {y:0, opacity: 1 },
};

export const skillAnimations = {
    hidden: {scale: 0, opacity:0 },
    show: {scale:1, opacity: 1 },
}

export const testimonialsAnimations = {
    hidden: {scale: 0, opacity:0 },
    show: {scale:1, opacity: 1 },
}

export const contactAnimations = {
    hidden: {y: 200, opacity:0 },
    show: {y:0, opacity: 1 },
};

export const footerTextAnimations = {
    hidden: {x: -200, opacity:0 },
    show: {x:0, opacity: 1 },
};
